import { useForm } from "react-hook-form";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../Context/Historico";
import { ReabrirCasoController } from "../../../../Controllers/Geral/Atendimentos/AtendimentosController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { Spinner } from "../../../Loding/SpinnerPadrao";

interface IFormDataProps {
    justificativa: string;
}

interface IPropsModal {
    setShow: (show: boolean) => void;
    ID_CASO: number;
}

export function ReabrirCaso(props: IPropsModal) {
    const { register, formState, handleSubmit } = useForm();

    const { updateAtendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const ReabrirCaso = useAsyncCallback(ReabrirCasoController);

    function handleFormSubmit(formData: IFormDataProps) {
        ReabrirCaso.execute({
            ID_CASO: props.ID_CASO,
            DS_JUSTIFICATIVA: formData.justificativa,
        }).then(() => {
            props.setShow(false);
            updateAtendimento?.();
            ReloadHistorico?.();
        });
    }

    return (
        <form onSubmit={handleSubmit(handleFormSubmit)}>
            <textarea
                name="justificativa"
                className={`form-control placeholder-dark-45 mt-5 mh-100 ${
                    formState.errors.justificativa && "is-invalid"
                }`}
                placeholder="Justificativa"
                style={{ minHeight: "40px", height: "150px" }}
                ref={register({
                    required: "Insira uma justificativa",
                })}
            />
            <div className="invalid-feedback">
                {formState.errors.justificativa
                    ? formState.errors.justificativa.message
                    : ""}
            </div>

            <button
                className="btn btn-outline-success font-weight-bold d-flex col-12 justify-content-center mt-5 d-flex align-items-center g-2"
                disabled={ReabrirCaso.loading}
            >
                {ReabrirCaso.loading && <Spinner size="sm" />} Confirmar
                Reabertura
            </button>
        </form>
    );
}
